export enum ChannelType {
    School = "school-news",
    Department = "departments",
    Service = "services",
}
